import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { LanguageDataEvent } from "../../event/LanguageDataEvent";
import { BasicDialogHandler } from "../../model/components/BasicDialogHandler";
import { FlashUIComponent } from "../FlashUIComponent";

import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;
import Shape = createjs.Shape;

export class BasicDialog extends FlashUIComponent {
    public static NAME: string = "BasicDialog";
    protected bg: Shape;
    protected dispBounds: Rectangle;
    protected showBackground: boolean = true;
    protected backgroundAlpha: number = 0.3;
    protected backgroundColor: string = "#000000";

    /**
     * Dialog has Background
     */
    constructor(disp: Container) {
        super(disp);
        this.dispBounds = disp.getBounds();
    }

    protected onBGAddedToStage(event: Event): void {
        this.bg.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onBGAddedToStage));
        this.bg.updateBounds();
        this.bg.width = this.bg.stage.stageWidth;
        this.bg.height = this.bg.stage.stageHeight;
        this.bg.x = -this.disp.x;
        this.bg.y = -this.disp.y;

        this.bg.graphics.clear().beginFill(this.backgroundColor).drawRect(this.bg.x, this.bg.y, this.bg.width, this.bg.height).endFill();
        this.bg.cacheCanvas ? this.bg.updateCache() : this.bg.cache( this.bg.x, this.bg.y, this.bg.width, this.bg.height );
    };

    /*override*/
    protected init(): void {
        this.initBackground();
        super.init();
        this.addEventListenerOnInit();
    }

    /**
     * use Signal.add or object.addEventListener in this method
     */
    protected addEventListenerOnInit(): void {

    }

    protected initBackground(): void {
        this.bg = new Shape();

        if (this.showBackground) {
            this.bg.alpha = this.backgroundAlpha;
        }
        else {
            this.bg.alpha = 0;
        }
        this.bg.graphics.clear().beginFill(this.backgroundColor).drawRect(0, 0, 1, 1).endFill();

        this.bg.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onBGAddedToStage));
        (this.disp as Container).addChildAt(this.bg, 0);
    }

    /*override*/
    public show(): void {
        super.show();
        this.addEventListenerOnShow();
    }

    /**
     * use Signal.add or object.addEventListener in this method
     */
    protected addEventListenerOnShow(): void {

    }

    protected removeBackground(): void {
        if (this.bg) {
            if ((this.disp as Container).contains(this.bg)) {
                (this.disp as Container).removeChild(this.bg);
            }
            this.bg.uncache();
            this.bg = null;
        }
    }

    /*override*/
    public hide(): void {
        super.hide();
        this.removeEventListenerOnHide();
        this.basicDialogHandler.onHideCurrentDialog();
    }

    /**
     * use Signal.remove or object.removeEventListener in this method
     */
    protected removeEventListenerOnHide(): void {

    }

    /*override*/
    public destroy(): void {
        super.destroy();
        this.removeEventListenerOnDestroy();
    }

    /**
     * use Signal.remove or object.removeEventListener in this method
     */
    protected removeEventListenerOnDestroy(): void {

    }

    /**
     * resize bg while resize the stage
     *
     */

    protected onResize(event: Event): void {
        this.updateBackground();
    }

    protected updateBackground(): void {
        if (!this.bg || !this.bg.stage) {
            return;
        }

        this.bg.width = this.bg.stage.width / this.disp.scaleX;
        this.bg.width = this.bg.stage.height / this.disp.scaleY;
        this.bg.x = -this.disp.x / this.disp.scaleX;
        this.bg.y = -this.disp.y / this.disp.scaleY;

        this.bg.graphics.clear().beginFill(this.backgroundColor).drawRect(this.bg.x, this.bg.y, this.bg.width, this.bg.height).endFill();
        this.bg.cacheCanvas ? this.bg.updateCache() : this.bg.cache( this.bg.x, this.bg.y, this.bg.width, this.bg.height );
    }

    /**
     * set position to the middle of the screen
     */
    /*override*/
    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            let scaleFactor: number = 1;

            if (this.disp.stage.stageWidth < this.dispBounds.width) {
                scaleFactor = this.disp.stage.stageWidth / this.dispBounds.width;
            }

            if (this.disp.stage.stageHeight < (this.dispBounds.height * scaleFactor)) {
                scaleFactor = this.disp.stage.stageHeight / this.dispBounds.height;
            }

            this.disp.x = -(this.dispBounds.x * scaleFactor) - (this.dispBounds.width * scaleFactor) * 0.5 + this.disp.stage.stageWidth * 0.5;
            this.disp.y = -(this.dispBounds.y * scaleFactor) - (this.dispBounds.height * scaleFactor) * 0.5 + this.disp.stage.stageHeight * 0.5;

            this.disp.scaleX = this.disp.scaleY = scaleFactor;
            this.disp.x = this.disp.x | 0;
            this.disp.y = this.disp.y | 0;
        }
    }

    protected get basicDialogHandler(): BasicDialogHandler {
        return BasicDialogHandler.getInstance();
    }

    protected onMouseOver(event: MouseEvent): void {
        this.onCursorOver(event);
    };

    protected onMouseOut(event: MouseEvent): void {
        this.onCursorOut(event);
    };

    protected onCursorOver(event: MouseEvent): void {
    };

    protected onCursorOut(event: MouseEvent): void {
    };

    public checkWaitingAnimState(message: string): void {
    }

    // protected get basicController(): BasicController {
    //     return BasicController.getInstance();
    // }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

